import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    en: {
        translation: {
            appName: "PiMail",
            enterUsername: "Enter Username",
            selectDomain: "Select Domain",
            create: "Create",
            random: "Random",
            cancel: "Cancel",
            copy: "Copy",
            refresh: "Refresh",
            newMailbox: "New",
            delete: "Delete",
            emptyInboxTitle: "Empty Inbox",
            emptyInboxSubtitle: "No messages yet. Share your address to receive mail.",
            fetching: "Fetching...",
            inbox: "Inbox",
            from: "From",
            subject: "Subject",
            date: "Date",
            noMessageSelected: "No message selected",
            attachments: "Attachments",
        },
    },
    vi: {
        translation: {
            appName: "PiMail",
            enterUsername: "Nhập tên hộp thư",
            selectDomain: "Chọn tên miền",
            create: "Tạo",
            random: "Ngẫu nhiên",
            cancel: "Hủy",
            copy: "Sao chép",
            refresh: "Làm mới",
            newMailbox: "Mới",
            delete: "Xóa",
            emptyInboxTitle: "Hộp thư trống",
            emptyInboxSubtitle: "Chưa có email nào. Hãy chia sẻ địa chỉ để nhận thư.",
            fetching: "Đang tải...",
            inbox: "Hộp thư đến",
            from: "Người gửi",
            subject: "Tiêu đề",
            date: "Thời gian",
            noMessageSelected: "Chưa chọn email",
            attachments: "Tệp đính kèm",
        },
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;

